import { Component } from '@angular/core';

@Component({
    selector: 'lockbin-private',
    templateUrl: './private.component.html',
    styles: [],
    standalone: false
})
export class PrivateComponent {

}
